import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import currency from 'currency.js'
import { Button, Input, InputError } from '@foodsby/nutrient'
import { Submitting } from '../common/Submitting'
import { useStateValue } from '../../providers/ProviderCheckout'

export const AddCredit = ({
  applyCredit,
  availableCredits,
  error,
  isAvailableCreditsLoading,
  isCheckoutCartLoading,
  isCreditApplying,
  setValue,
  value,
}) => {
  const [{ subscription }] = useStateValue()

  return (
    <div className="Input Input--attached">
      <div>
        <label htmlFor="credit">Credit Amount</label>
      </div>
      <div className="Input--attachedSet ">
        <Input
          allowNegative={false}
          decimalScale={2}
          displayType="input"
          fixedDecimalScale
          onKeyDown={e =>
            e.keyCode === 13 && applyCredit(value, subscription.value)
          }
          onValueChange={values => setValue(values.value)}
          prefix="$"
          value={value}
        />

        {isCreditApplying ? (
          <Submitting text="Applying" />
        ) : (
          <Button
            className="button secondary"
            disabled={!value || isCheckoutCartLoading}
            onClick={event => {
              event.preventDefault()
              applyCredit(value, subscription.value)
            }}
            type="button"
          >
            Apply
          </Button>
        )}
      </div>
      {!isAvailableCreditsLoading && availableCredits ? (
        <label htmlFor="credit">
          Total credits available:{' '}
          {currency(availableCredits, { formatWithSymbol: true }).format()}
        </label>
      ) : null}
      <InputError className="Input-error">{error}</InputError>
    </div>
  )
}

export const RemoveAppliedCredit = ({
  applyCredit,
  availableCredits,
  creditsUsed,
  error,
  isAvailableCreditsLoading,
  isCreditApplying,
  setValue,
}) => {
  const [{ subscription }] = useStateValue()

  return (
    <div className="Input Input--attached">
      <label htmlFor="credit">Credits Applied</label>
      <div className="Input--attachedSet ">
        <p className="Input-mockInput">
          {currency(creditsUsed, { formatWithSymbol: true }).format()}
        </p>

        {isCreditApplying ? (
          <Submitting text="Changing" />
        ) : (
          <Button
            className="button secondary"
            onClick={() => {
              applyCredit(0, subscription.value)
              setValue(creditsUsed)
            }}
            type="button"
          >
            Change
          </Button>
        )}
      </div>
      {!isAvailableCreditsLoading && availableCredits ? (
        <label htmlFor="credit">
          Total credits available:{' '}
          {currency(availableCredits, { formatWithSymbol: true }).format()}
        </label>
      ) : null}
      <InputError className="Input-error">{error}</InputError>
    </div>
  )
}
export const Credit = ({
  applyCredit,
  availableCredits,
  creditsApplied,
  creditsUsed,
  error,
  isAvailableCreditsLoading,
  isCheckoutCartLoading,
  isCreditApplying,
  suggestedCredits,
}) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(suggestedCredits)
  }, [suggestedCredits])

  return (
    <>
      {creditsApplied ? (
        <RemoveAppliedCredit
          applyCredit={applyCredit}
          availableCredits={availableCredits}
          creditsUsed={creditsUsed}
          error={error}
          isAvailableCreditsLoading={isAvailableCreditsLoading}
          isCheckoutCartLoading={isCheckoutCartLoading}
          isCreditApplying={isCreditApplying}
          setValue={setValue}
          value={value}
        />
      ) : (
        <AddCredit
          applyCredit={applyCredit}
          availableCredits={availableCredits}
          error={error}
          isAvailableCreditsLoading={isAvailableCreditsLoading}
          isCheckoutCartLoading={isCheckoutCartLoading}
          isCreditApplying={isCreditApplying}
          setValue={setValue}
          value={value}
        />
      )}
    </>
  )
}

Credit.propTypes = {
  applyCredit: PropTypes.func,
  availableCredits: PropTypes.number,
  creditsApplied: PropTypes.bool,
  creditsUsed: PropTypes.number,
  error: PropTypes.string,
  isAvailableCreditsLoading: PropTypes.bool,
  isCheckoutCartLoading: PropTypes.bool,
  isCreditApplying: PropTypes.bool,
  suggestedCredits: PropTypes.number,
}

export default Credit
